export const GET_GAMES_START = "GET_GAMES_START";
export const GET_GAMES_FINISH = "GET_GAMES_FINISH";
export const GET_GAMES_ERROR = "GET_GAMES_ERROR";
